import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "../../../components/Navbar";

export default function ProjectsLayout() {
    return (
        <div>
            <Navbar/>
            <Outlet/>
        </div>
    )
}